$(document).ready(function () {
    // Get URL parameters
    var urlParams = new URLSearchParams(window.location.search);

    // Decode the "Name" parameter
    var rawString = decodeURIComponent(urlParams.get("Name") || "");

    if (!rawString) {
        console.error("No valid data found in the URL.");
        // return;
    }

    // Extract the name (first part before ;)
    var firstSemicolonIndex = rawString.indexOf(';');

    var name = firstSemicolonIndex !== -1 ? rawString.substring(0, firstSemicolonIndex).replace(/[";]/g, '').trim() : rawString.trim();
    var data = JSON.parse(window.localStorage.getItem('quiz-data')).find(pet => pet.Name === name);
    if (!data) {
        console.error("No valid data found in the localStorage.");
    } else {
        console.log("Data found in the localStorage:", data);
    }
    // Extract the remaining key-value pairs
    var paramsObject = {};
    rawString.substring(firstSemicolonIndex + 1).split(';').forEach(pair => {
        let index = pair.indexOf('=');
        if (index !== -1) {
            let key = pair.substring(0, index).trim();
            let value = pair.substring(index + 1).replace(/[";]/g, '').trim();
            paramsObject[key] = value;
        }
    });
    var type = data.CatDog; //paramsObject["Type"] || "Unknown";
    var age = data.Old;//paramsObject["HowOld"] ? paramsObject["HowOld"].split('-')[0] : "Unknown";
    var color = data.Color;//paramsObject["WhatColor"] || "Unknown";
    var weight = data.Weight; //paramsObject["Weight"] || "Unknown";
    var allergies = data.Allergies;
    formatData();
    setResults();
    // var allergies = [];
    // if (paramsObject["Allergies"]) {
    //     var allergyString = paramsObject["Allergies"].replace(/^"|"$/g, ''); // Remove surrounding quotes
    //     allergies = allergyString.split(';').map(a => a.trim()).filter(Boolean);
    // }


    var title = $('.qz_product_meta .qz_mediumTitle').html();
    title = title.replace('(name)', name);
    $('.qz_product_meta .qz_mediumTitle').html(title);

    var text = $('.qz_product_meta .ppBody p').html();
    text = text.replace('[name]', name);
    $('.qz_product_meta .ppBody p').html(text);

    setProducts(type, age, color, allergies, weight);

    // sendDataToGoogleSheets(name, type, age, color, allergies, weight);

    function formatData() {
        if (type === 'Dog') {
            type = 'dog';
        } else {
            type = 'cat';
        }
        if (age.includes('Junior')) {
            age = 'junior';
        } else if (age.includes('Senior')) {
            age = 'senior';
        } else if (age.includes('Adult')) {
            age = 'adult';
        } else {
            age = 'puppy';
        }
        if (weight == 'Small') {
            weight = 'small';
        } else if (weight == 'Large') {
            weight = 'large';
        } else if (weight == 'Medium') {
            weight = 'medium';
        } else if (weight == 'Extra Large') {
            weight = 'extra-large';
        }
    }

    function setResults() {
        var allergies = data.Allergies.replace(/[";]/g, ', ');
        allergies = allergies.substring(0, allergies.length - 2);

        var results = $('<div class="result-list"></div>');
        var resultItem1 = $('<div class="result-item" ></div>').html('<span class="result-text">' + 'Pet Breed' + '</span><div class="result-gap"> </div><span class="result-text-right">' + data.petBreed + '</span>');
        var resultItem3 = $('<div class="result-item" ></div>').html('<span class="result-text">' + 'Life Stage' + '</span><div class="result-gap"> </div><span class="result-text-right">' + data.Old + '</span>');
        var resultItem2 = $('<div class="result-item" ></div>').html('<span class="result-text">' + 'Pet Weight' + '</span><div class="result-gap"> </div><span class="result-text-right">' + data.Weight + '</span>');
        var resultItem4 = $('<div class="result-item" ></div>').html('<span class="result-text">' + 'Pet Gender' + '</span><span class="result-gap"></span><span class="result-text-right">' + data.Sex + '</span>');
        var resultItem5 = $('<div class="result-item" ></div>').html('<span class="result-text">' + 'Body Condition' + '</span><span class="result-gap"></span><span class="result-text-right">' + data.Body + '</span>');
        var resultItem6 = $('<div class="result-item" ></div>').html('<span class="result-text">' + 'Allergies & Dislikes' + '</span><span class="result-gap"></span><span class="result-text-right">' + allergies + '</span>');
        results.append(resultItem1).append(resultItem2).append(resultItem3).append(resultItem4).append(resultItem5).append(resultItem6);

        $('.test-stats').html(results);
        $('.petName').text("Summary of " + data.Name + "'s Plan");
        $('.petName-split').text("How will this help " + data.Name + "?");
    }

    function setProducts(type, age, color, allergies, weight) {
        // allergies = allergies.join(', ');
        console.log(type, age, color, allergies, weight, 'TESTING HERE');
        // var product_title_position = $('#expert_description')[0];
        var product_title_text = "";
        if (type == 'dog') {

            if (String(age).indexOf('puppy') != -1) {
                if (String(weight).indexOf('small') != -1) {
                    if (String(color).indexOf('red-') != -1) {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="puppy-small-red-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-small-red-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="puppy-small-red-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-small-red-no"]').addClass('visible');
                        }
                    } else {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="puppy-small-all-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-small-all-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="puppy-small-all-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-small-all-no"]').addClass('visible');
                        }
                    }
                } else {
                    if (String(color).indexOf('red-') != -1) {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="puppy-medium-red-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-medium-red-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="puppy-medium-red-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-medium-red-no"]').addClass('visible');
                        }
                    } else {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="puppy-medium-all-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-medium-all-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="puppy-medium-all-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="puppy-medium-all-no"]').addClass('visible');
                        }
                    }
                }
            } else if (String(age).indexOf('junior') != -1) {
                if (String(weight).indexOf('small') != -1) {
                    if (String(color).indexOf('red-') != -1) {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="junior-small-red-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-small-red-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="junior-small-red-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-small-red-no"]').addClass('visible');
                        }
                    } else {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="junior-small-all-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-small-all-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="junior-small-all-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-small-all-no"]').addClass('visible');
                        }
                    }
                } else {
                    if (String(color).indexOf('red-') != -1) {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="junior-medium-red-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-medium-red-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="junior-medium-red-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-medium-red-no"]').addClass('visible');
                        }
                    } else {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="junior-medium-all-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-medium-all-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="junior-medium-all-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="junior-medium-all-no"]').addClass('visible');
                        }
                    }
                }
            } else if (String(age).indexOf('senior') != -1 || String(age).indexOf('adult') != -1) {
                if (String(weight).indexOf('small') != -1) {
                    if (String(color).indexOf('red-') != -1) {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="adult-small-red-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-small-red-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="adult-small-red-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-small-red-no"]').addClass('visible');
                        }
                    } else {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="adult-small-all-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-small-all-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="adult-small-all-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-small-all-no"]').addClass('visible');
                        }
                    }
                } else {
                    if (String(color).indexOf('red-') != -1) {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="adult-medium-red-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-medium-red-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="adult-medium-red-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-medium-red-no"]').addClass('visible');
                        }
                    } else {
                        if (String(allergies).indexOf('tuna') != -1 || String(allergies).indexOf('salmon') != -1 || String(allergies).indexOf('fish') != -1) {
                            $('.qz_products_grid[data-category="adult-medium-all-yes"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-medium-all-yes"]').addClass('visible');
                        } else {
                            $('.qz_products_grid[data-category="adult-medium-all-no"]').addClass('visible');
                            $('.qz_products_grid_justtitle[data-category="adult-medium-all-no"]').addClass('visible');
                        }
                    }
                }
            }
        } else if (type == 'cat') {

            if (String(color).indexOf('red-') != -1) {
                $('.qz_products_grid[data-category="cat-red"]').addClass('visible');
                var temp = $('.qz_products_grid[data-category="cat-red"]').first();
                $('.qz_products_grid_justtitle[data-category="cat-red"]').addClass('visible');
                product_title_text = temp.data('title');
            } else if (String(color).indexOf('dark') != -1) {
                $('.qz_products_grid[data-category="cat-dark"]').addClass('visible');
                var temp = $('.qz_products_grid[data-category="cat-dark"]').first();
                $('.qz_products_grid_justtitle[data-category="cat-dark"]').addClass('visible');
                product_title_text = temp.attr('data-title');

            } else {
                $('.qz_products_grid[data-category="cat-all"]').addClass('visible');
                var temp = $('.qz_products_grid[data-category="cat-all"]').first();
                $('.qz_products_grid_justtitle[data-category="cat-all"]').addClass('visible');
                product_title_text = temp.data('title');

            }
        }
        var product_title_position = $('#expert_description')[0];
        var text_temp = product_title_position.textContent;
        text_temp = text_temp.replace("[product name]", product_title_text);
        product_title_position.textContent = text_temp;
        $('.qz_prods_outer').addClass('loaded');

        setTimeout(function () {
            $('.visible .pp_variant_sel.active').trigger('click');
        }, 1000);
    }


    $('.carousel-next').on('click', function () {
        var current = $('.carousel-item:visible');
        var next = current.next('.carousel-item');
        if (next.length) {
            current.addClass('hidden').removeClass('visible');
            next.addClass('visible').removeClass('hidden');
        }
    });

    $('.carousel-previous').on('click', function () {
        var current = $('.carousel-item:visible');
        var prev = current.prev('.carousel-item');
        if (prev.length) {
            current.addClass('hidden').removeClass('visible');
            prev.addClass('visible').removeClass('hidden');
        }
    });

});